import { openAPIClient } from '@/services/httpServices/openApiClient';

import type {
  ABTestCreateResponse,
  ABTestGetResponse,
  ABTestListResponse,
  ABTestListServiceConfig,
  ABTestUpdateResponse,
  CreateABTestServiceConfig,
  DeleteABTestServiceConfig,
  GetABTestByIdServiceConfig,
  UpdateABTestServiceConfig,
} from './types';

export async function getABTestListService({
  httpRequestConfig,
  params,
}: ABTestListServiceConfig): Promise<ABTestListResponse> {
  const client = await openAPIClient(httpRequestConfig);
  if (params === undefined) {
    throw new Error('Params are required');
  }

  const response = await client.GET('/v1/auth/abtest', {
    params: {
      query: params.query,
    },
  });

  if (response.error !== undefined) {
    throw new Error(response.error.message);
  }

  return response.data;
}

export async function getABTestByIdService({
  httpRequestConfig,
  params,
}: GetABTestByIdServiceConfig): Promise<ABTestGetResponse> {
  const client = await openAPIClient(httpRequestConfig);
  if (params === undefined) {
    throw new Error('Params are required');
  }

  const response = await client.GET('/v1/auth/abtest/{id}', {
    params: {
      path: { id: params.id },
    },
  });

  if (response.error !== undefined) {
    throw new Error(response.error.message);
  }

  return response.data;
}

export async function createABTestService({
  httpRequestConfig,
  params,
}: CreateABTestServiceConfig): Promise<ABTestCreateResponse> {
  const client = await openAPIClient(httpRequestConfig);
  if (params === undefined) {
    throw new Error('Params are required');
  }

  const response = await client.POST('/v1/auth/abtest', {
    body: params.body,
  });

  if (response.error !== undefined) {
    throw new Error(response.error.message);
  }

  return response.data;
}

export async function updateABTestService({
  httpRequestConfig,
  params,
}: UpdateABTestServiceConfig): Promise<ABTestUpdateResponse> {
  const client = await openAPIClient(httpRequestConfig);
  if (params === undefined) {
    throw new Error('Params are required');
  }

  const response = await client.PUT('/v1/auth/abtest/{id}', {
    params: {
      path: { id: params.params.id },
    },
    body: params.body,
  });

  if (response.error !== undefined) {
    throw new Error(response.error.message);
  }

  return response.data;
}

export async function deleteABTestService({
  httpRequestConfig,
  params,
}: DeleteABTestServiceConfig): Promise<void> {
  const client = await openAPIClient(httpRequestConfig);
  if (params === undefined) {
    throw new Error('Params are required');
  }

  const response = await client.DELETE('/v1/auth/abtest/{id}', {
    params: {
      path: {
        id: params.id,
      },
    },
  });

  if (response.error !== undefined) {
    throw new Error(response.error.message);
  }
}
